"use client";

import { createContext, useContext } from "react";

export interface StepperContextValue {
  setStepValid: (valid: boolean) => void;
  isStepValid: boolean;
  currentStep: number;
  totalSteps: number;
  goToNextStep: () => void;
  goToPreviousStep: () => void;
}

export const StepperContext = createContext<StepperContextValue | null>(null);

export const useStepper = () => {
  const context = useContext(StepperContext);
  if (!context) {
    throw new Error("useStepper must be used within a Stepper component");
  }
  return context;
};

